import { Box, Card, CardContent, Typography, Grid, Skeleton } from '@mui/material';
import { formatCurrency } from '@/utils/misc';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { TransactionStatsDTO } from '@inversor-hub/types';
import { FC } from 'react';

interface TransactionStatsProps {
  stats?: TransactionStatsDTO;
  isLoading?: boolean;
}

export const TransactionStats: FC<TransactionStatsProps> = ({ stats, isLoading }) => {
  if (isLoading) {
    return (
      <Grid container spacing={2}>
        {[1, 2, 3].map((i) => (
          <Grid item xs={12} sm={4} key={i}>
            <Skeleton variant="rectangular" height={120} />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!stats) return null;

  const netColor = stats.netCashflow >= 0 ? 'success.main' : 'error.main';

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <TrendingDownIcon color="error" sx={{ mr: 1 }} />
              <Typography variant="subtitle2" color="text.secondary">
                Total Gastos
              </Typography>
            </Box>
            <Typography variant="h5" fontWeight={600} color="error.main">
              {formatCurrency(stats.totalExpenses)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {stats.expenseCount} transacciones
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <TrendingUpIcon color="success" sx={{ mr: 1 }} />
              <Typography variant="subtitle2" color="text.secondary">
                Total Ingresos
              </Typography>
            </Box>
            <Typography variant="h5" fontWeight={600} color="success.main">
              {formatCurrency(stats.totalIncome)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {stats.incomeCount} transacciones
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={4}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Box display="flex" alignItems="center" mb={1}>
              <AccountBalanceWalletIcon sx={{ mr: 1, color: netColor }} />
              <Typography variant="subtitle2" color="text.secondary">
                Flujo Neto
              </Typography>
            </Box>
            <Typography variant="h5" fontWeight={600} sx={{ color: netColor }}>
              {formatCurrency(stats.netCashflow)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Ingresos - Gastos
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
